import { h } from 'preact';
import SVGCreator from '../../../../common/components/svg/SVGCreator';
import { useNewStore } from '../../../../common/hooks';
import { FRANCEINFO_SOURCE, FRANCETV_SOURCE } from '../../../../common/theme/svg';
import { getSizeFactor } from '../../../../common/utils/tools';
import { withBreakPoints } from '../../../hoc';
import { SOURCE_BUTTON_SIZE, SOURCE_BUTTON_STYLE } from './styles';

const resolveLogo = (source) => (source === 'franceinfo' ? FRANCEINFO_SOURCE : FRANCETV_SOURCE);

function SourceButton({ extraSmall, large, hidden }) {
  const { originUrl, origin } = useNewStore('ui');

  return !hidden && (
    <div
      role="presentation"
      style={SOURCE_BUTTON_STYLE}
      onClick={(e) => { e.stopPropagation(); window.open(originUrl); }}
    >
      <SVGCreator
        paths={resolveLogo(origin)}
        width={SOURCE_BUTTON_SIZE.width * getSizeFactor({ extraSmall, large })}
        height={SOURCE_BUTTON_SIZE.height * getSizeFactor({ extraSmall, large })}
      />
    </div>
  );
}

export default withBreakPoints(SourceButton);
